import React from 'react'
import PropTypes from 'prop-types'
import { lifecycle } from 'recompose'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import { formatDate } from '../../../../util/datetime'
import currentUserHasAccess from '../../../../util/widget-helper'
import { MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'


const Match3Shape = ({ customer, caseList, context, changeProcessContext, saveProcessContext, readOnly, validationMessageList }) => {
    if (!currentUserHasAccess(MATCH_3SHAPE_CUSTOMER_WIDGET_CONTAINER)) {
        return null
    }

    return (
        <ContentBox title="Match 3Shape">

            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList}/>
                </Column>
            </Row>
            <Row>
                <Column size={6}>
                    <LabelInput label="3Shape Case">
                        <Select object={context}
                            name="threeShapeCaseId"
                            valueList={caseList}
                            addEmpty={true}
                            renderer={(threeShapeCase) => {
                                return threeShapeCase.firstName + ' ' + threeShapeCase.lastName + ' (' + formatDate(threeShapeCase.original.UpdatedOn) + ')'
                            }}
                            readOnly={readOnly}
                            onChange={(name, value) => {
                                changeProcessContext(name, value)
                                saveProcessContext()
                            }}/>
                    </LabelInput>
                </Column>
                <Column size={6}/>
            </Row>


        </ContentBox>
    )
}

Match3Shape.propTypes = {
    customer: PropTypes.object,
    caseList: PropTypes.array.isRequired,
    context: PropTypes.object,
    findUnassignedCaseList: PropTypes.func.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.findUnassignedCaseList()
    },
})(Match3Shape)




// WEBPACK FOOTER //
// ./src/modules/threeshape/component/match/Match3ShapeCustomer.js